import {FullWidthTextField} from "@src/Shared/styles";
import styled, {keyframes} from "styled-components";
import {Tooltip, Typography} from "@material-ui/core";

export const TokenTextField = styled(FullWidthTextField)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CopyButton = styled(Tooltip)`
  margin-left: 10px;
`;

export const TokenExpiresText = styled(Typography)`
  align-self: center;
  color: red;
  padding-right: 8px;
`;

export const TokenExpiresWrapper = styled.div`
    display: flex;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.span`
  width: 20px;
  height: 20px;
  border: 2px solid #616161;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`;